import type { MermaidConfig } from "mermaid";

export const mermaidConfig: MermaidConfig = {
  startOnLoad: false,
  suppressErrorRendering: true,
  theme: "base",
  securityLevel: "strict",
  themeVariables: {
    // General
    darkMode: false,
    background: "#FFFFFF",
    fontFamily: "Inter, sans-serif",
    fontSize: "12px",
    primaryColor: "#EEF2FF",
    primaryTextColor: "#1F2537",
    primaryBorderColor: "#8085FF",
    secondaryColor: "#F9FDEC",
    secondaryTextColor: "#1F2537",
    secondaryBorderColor: "#9ED334",
    tertiaryColor: "#FFFBEB",
    tertiaryTextColor: "#373D51",
    tertiaryBorderColor: "#FBBF24",
    lineColor: "#9C9FAF",
    textColor: "#4B5163",

    // Notes
    noteBkgColor: "#FDF2F8",
    noteTextColor: "#373D51",
    noteBorderColor: "#FBCFE8",

    // Flowchart
    nodeBorder: "#8085FF",
    clusterBkg: "#F9FAFB",
    clusterBorder: "#E5E6EB",
    defaultLinkColor: "#9C9FAF",
    titleColor: "#1F2537",
    edgeLabelBackground: "#FFFFFF",
    nodeTextColor: "#1F2537",

    // Sequence
    actorBkg: "#EEF2FF",
    actorBorder: "#8085FF",
    actorTextColor: "#1F2537",
    actorLineColor: "#D1D3DB",
    signalColor: "#6B6F80",
    signalTextColor: "#373D51",
    labelBoxBkgColor: "#F9FDEC",
    labelBoxBorderColor: "#9ED334",
    labelTextColor: "#373D51",
    loopTextColor: "#5E9605",
    activationBorderColor: "#8085FF",
    activationBkgColor: "#E0E5FF",
    sequenceNumberColor: "#FFFFFF",

    // Pie
    pie1: "#8085FF",
    pie2: "#9ED334",
    pie3: "#FBBF24",
    pie4: "#38BDF8",
    pie5: "#F472B6",
    pie6: "#34D399",
    pie7: "#FB923C",
    pie8: "#60A5FA",
    pie9: "#FB7185",
    pie10: "#A78BFA",
    pie11: "#2DD4BF",
    pie12: "#0284C7",
    pieTitleTextSize: "14px",
    pieTitleTextColor: "#1F2537",
    pieSectionTextSize: "12px",
    pieSectionTextColor: "#FFFFFF",
    pieLegendTextSize: "12px",
    pieLegendTextColor: "#4B5163",
    pieStrokeColor: "#FFFFFF",
    pieStrokeWidth: "1px",
    pieOuterStrokeWidth: "0px",
    pieOuterStrokeColor: "#FFFFFF",
    pieOpacity: "0.9",

    // State / Class / Journey
    labelColor: "#1F2537",
    altBackground: "#F9FAFB",
    classText: "#1F2537",
    fillType0: "#EEF2FF",
    fillType1: "#F9FDEC",
    fillType2: "#FFFBEB",
    fillType3: "#F0F9FF",
    fillType4: "#FDF2F8",
    fillType5: "#ECFDF5",
    fillType6: "#FFF7ED",
    fillType7: "#EFF6FF",
  },
};
